
import ListComponent from "../../../components/loser_items/Index.vue";

export default {
  components: {
    ListComponent,
  },
};
